import web3 from "web3";

export const formatToWei = (v: any, d: any) => {
    if (d === 6)
        return web3.utils.toWei(v, "picoether");
    else if (d === 9)
        return web3.utils.toWei(v, "nanoether");
    else if (d === 12)
        return web3.utils.toWei(v, "microether");
    else
        return web3.utils.toWei(v, "ether");
};

export const formatFromWei = (v: any, d: any) => {
    let v_new = Math.trunc(Number(v))
    if (d === 6)
        return web3.utils.fromWei(v_new, "picoether");
    else if (d === 9)
        return web3.utils.fromWei(v_new, "nanoether");
    else if (d === 12)
        return web3.utils.fromWei(v_new, "microether");
    else
        return web3.utils.fromWei(v_new, "ether");
};